"use client";

import type { genericBooleanSchema } from "../../../../lib/types/schema/genericBooleanSchema";
import { useRequestMutation } from "../../../../request/hooks/useRequestMutation";

export const useRequestQueueCurrentItemIndex = () => ({
  mutatePut: useRequestMutation<
    typeof genericBooleanSchema,
    { current_item_index: number }
  >({
    mutationFnRequestProps: (data) => ({
      body: JSON.stringify(data),
      method: "PUT",
      urlBackendPath: "/queue/current-item-index",
    }),
  }),
});
